import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Button, Typography, Alert, Grid, TextField, InputAdornment, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ExpandedTooltip, Icon, toast, BackdropLoader } from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { translate } from 'src/utils/translator';
import useStyles from './styles';
import { useFormik } from 'formik';
import { propertyPayoutDetailsInitVales, propertyPayoutDetailsValidationScheme } from 'src/utils/formValidation/AddNewProperty';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { PAYMENT_METHODS } from 'src/constants/payments';
export const ModalContent = observer(_ref => {
  let handleClose = _ref.handleClose,
    triggerRefresh = _ref.triggerRefresh,
    propertyIdExternal = _ref.propertyIdExternal;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const classes = useStyles();
  const store = useStore();
  const selectedPropertyPaymentMethod = null;
  // NOTE: no editing
  // const selectedPropertyPaymentMethod = store.homeDashboardStore.getCurrentCompany.getPropertyReimbursementMethods(
  //   store.homeDashboardStore.getCurrentProperty?.id
  // );
  const formik = useFormik({
    initialValues: selectedPropertyPaymentMethod !== null ? _objectSpread(_objectSpread({}, selectedPropertyPaymentMethod), {}, {
      paymentMethod: selectedPropertyPaymentMethod === null || selectedPropertyPaymentMethod === void 0 ? void 0 : selectedPropertyPaymentMethod.methodType
    }) : propertyPayoutDetailsInitVales,
    validationSchema: propertyPayoutDetailsValidationScheme,
    onSubmit: async _ref2 => {
      var _store$homeDashboardS;
      let nameOnAccount = _ref2.nameOnAccount,
        depositoryName = _ref2.depositoryName,
        routingNumber = _ref2.routingNumber,
        accountNumber = _ref2.accountNumber,
        paymentMethod = _ref2.paymentMethod;
      const propertyId = propertyIdExternal !== null && propertyIdExternal !== void 0 ? propertyIdExternal : (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id;
      const finalizeSave = _ref3 => {
        let isEdit = _ref3.isEdit;
        if (isEdit) {
          toast('success', {
            body: ['Reimbursement details successfully updated!']
          });
        } else {
          toast('success', {
            body: ['Reimbursement details successfully added!']
          });
        }
        handleClose();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        triggerRefresh && triggerRefresh(propertyId);
      };
      try {
        var _response;
        let response;
        if (nameOnAccount && depositoryName && routingNumber && accountNumber) {
          const reqData = {
            propertyId,
            nameOnAccount,
            depositoryName,
            routingNumber,
            accountNumber,
            isPrimary: paymentMethod === PAYMENT_METHODS.ACH,
            id: selectedPropertyPaymentMethod !== null ? selectedPropertyPaymentMethod.id : undefined
          };
          if (reqData !== null && reqData !== void 0 && reqData.id) {
            response = await store.payment.putPayoutAchDirectDepositAsync.run(reqData, [propertyId]);
          } else {
            // response = await store.payment.postPayoutAchDirectDepositAsync.run(reqData, [propertyId]);
            const createPayoutMethodResultResponse = await store.payment.postCompanyPayoutMethodAsync.run(reqData, [propertyId]);
            if (createPayoutMethodResultResponse !== null && createPayoutMethodResultResponse !== void 0 && createPayoutMethodResultResponse.isSuccessful) {
              var _createPayoutMethodRe;
              response = await store.payment.assignCompanyPayoutMethodToPropertyAsync.run({
                payoutMethodId: (_createPayoutMethodRe = createPayoutMethodResultResponse.response) === null || _createPayoutMethodRe === void 0 ? void 0 : _createPayoutMethodRe.id,
                propertyId: propertyId
              }, [propertyId]);
            }
          }
        }

        // if (payeeName && payeeAddress) {
        //   // const reqData = {
        //   //   propertyId,
        //   //   payeeName,
        //   //   payeeAddress,
        //   //   isPrimary: paymentMethod === PAYMENT_METHODS.RegularCheck,
        //   //   id: selectedPropertyPaymentMethod !== null ? selectedPropertyPaymentMethod.id : undefined,
        //   // };
        //   // NOTE: disabled check payout LB-1758
        //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
        //   // response = reqData?.id
        //   //   ? await store.payment.putPayoutRegularCheckAsync.run(reqData, [propertyId])
        //   //   : await store.payment.postPayoutRegularCheckAsync.run(reqData, [propertyId]);
        //   // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        //   // !!response?.isSuccessful &&
        //   // toast('success', {
        //   //   body: [
        //   //     achDepositDataPaymentId
        //   //       ? t('general.successfully_updated')
        //   //       : 'Successfully added',
        //   //   ],
        //   // });
        // }

        if ((_response = response) !== null && _response !== void 0 && _response.isSuccessful) finalizeSave({
          isEdit: selectedPropertyPaymentMethod !== null
        });
      } catch (error) {
        console.log('Error', error);
      }
    }
  });
  const isLoading = () => {
    return store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.reimbursement_hint_NBM_modal'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(HelpCenterButton, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerText
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.ach_direct_deposit')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.ach_form_hint')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.hereby_authorize')))), /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "nameOnAccount",
    name: "nameOnAccount",
    label: t('add_new_property_flow.name_on_the_account'),
    variant: "outlined",
    value: formik.values.nameOnAccount,
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.name_on_account_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    error: formik.touched.nameOnAccount && Boolean(formik.errors.nameOnAccount),
    helperText: formik.touched.nameOnAccount && translate(t(formik.errors.nameOnAccount, {
      field: t('general.email_address')
    }), t),
    fullWidth: true
    // disabled={isDisabled}
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "depositoryName",
    name: "depositoryName",
    label: t('add_new_property_flow.depository_name'),
    variant: "outlined",
    value: formik.values.depositoryName,
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.depository_name_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    error: formik.touched.depositoryName && Boolean(formik.errors.depositoryName),
    helperText: formik.touched.depositoryName && translate(t(formik.errors.depositoryName, {
      field: t('general.email_address')
    }), t),
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "routingNumber",
    name: "routingNumber",
    label: t('add_new_property_flow.routing_number'),
    variant: "outlined",
    value: formik.values.routingNumber,
    onBlur: formik.handleBlur,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.routing_number_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^[0-9][0-9]*$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    error: formik.touched.routingNumber && Boolean(formik.errors.routingNumber),
    helperText: formik.touched.routingNumber && translate(t(formik.errors.routingNumber, {
      field: t('general.email_address')
    }), t),
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "accountNumber",
    name: "accountNumber",
    label: t('add_new_property_flow.account_number'),
    variant: "outlined",
    value: formik.values.accountNumber,
    onBlur: formik.handleBlur,
    onKeyPress: event => {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^[0-9][0-9]*$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end",
        type: "infoTooltip"
      }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
        type: "grey",
        title: t('add_new_property_flow.account_number_tooltip'),
        placement: "top"
      }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
        type: "question"
      }))))
    },
    error: formik.touched.accountNumber && Boolean(formik.errors.accountNumber),
    helperText: formik.touched.accountNumber && translate(t(formik.errors.accountNumber, {
      field: t('general.email_address')
    }), t),
    fullWidth: true
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.authorization_details')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.authorization_text')))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      handleClose();
    },
    disabled: isLoading(),
    'custom-attribute': '682-new-billing-module'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: formik.handleSubmit,
    disabled: isLoading(),
    'custom-attribute': '683-new-billing-module'
  }, t('Save payment')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading()
  }));
});